<template>
  <ValidationProvider v-slot="{ errors }"
                      :name="name"
                      :rules="rules"
                      tag="div"
  >
    <AGCLabel v-if="label" :required="required">
      <slot>{{ label }}</slot>
      <template v-slot:subLabel>
        <slot name="subLabel">{{ subLabel }}</slot>
      </template>
    </AGCLabel>
    <b-form-group>
      <b-form-radio-group v-model="inputVal"
                          :options="options"
                          :state="state(errors)"
                          :placeholder="placeholder"
                          :required="required"
                          :disabled="disabled"
                          @change="$emit('change')"
      >
        <b-form-invalid-feedback :state="state(errors)">
          {{ errors[0] }}
        </b-form-invalid-feedback>
      </b-form-radio-group>
    </b-form-group>
  </ValidationProvider>
</template>

<script>
import {
  BFormGroup,
  BFormRadioGroup,
  BFormInvalidFeedback,
} from 'bootstrap-vue';
import agcFormElementMixin from '../../mixins/agc-form-element';

export default {
  components: {
    BFormGroup,
    BFormRadioGroup,
    BFormInvalidFeedback,
  },
  mixins: [agcFormElementMixin],
  props: {
    options: Array,
  },
};
</script>
